import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../Dashboard/layout';
import { Form } from 'react-bootstrap';
import { Headings } from '../RegisteredUsersList/ViewRegList';

const AddSocialLinks = () => {
  const [socialData, setSocialData] = useState({
    name: '', // Social link name (Facebook, Twitter, LinkedIn)
    url: '', // URL for the social link
    accountStatus: '', // Status field for active or inactive
    image: null,
    imagePreview: null // For image preview
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSocialData({
      ...socialData,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSocialData({
        ...socialData,
        image: file,
        imagePreview: URL.createObjectURL(file) // Image preview
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    const urlRegex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9]{2,}(\/[^\s]*)?$/;
    if (socialData.url && !urlRegex.test(socialData.url)) {
      errors.url = 'Please enter a valid URL';
    }
    if (!socialData.accountStatus) errors.accountStatus = 'Status is required';
    if (!socialData.image) errors.image = 'Image is required';
    if (!socialData.name) errors.name = 'Social link name is required';

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      Swal.fire('Error', 'Please fill in all required fields correctly', 'error');
      return;
    }

    try {
      const form = new FormData();
      form.append('name', socialData.name);
      form.append('url', socialData.url);
      form.append('accountStatus', socialData.accountStatus);
      form.append('image', socialData.image); // Append the image as well

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/social-links`,
        form,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (res.data.status === 0) {
        Swal.fire('Error', 'Social link already exists!', 'error');
      } else {
        Swal.fire('Success', 'Social link added successfully!', 'success').then(() => {
          navigate('/social-links'); // Redirect to the social links page
        });
      }
    } catch (error) {
      console.error('Error submitting data', error);
      Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
    }
  };

  return (
    <DashboardLayout>
      <section className="MainDivSec">
         <Headings headspan="Add Social" hedtext=" Links" />
        <div className="AdduserFormDiv">
          <Form onSubmit={handleSubmit}>
            <div className="FormGroupDiv">
              <label>Social Link Name:</label>
              <input
                type="text"
                name="name"
                value={socialData.name}
                onChange={handleInputChange}
                placeholder="Enter Social Link Name (e.g. Facebook, Twitter, LinkedIn)"
                required
              />
            </div>

            <div className="FormGroupDiv">
              <label>URL:</label>
              <input
                type="url"
                name="url"
                value={socialData.url}
                onChange={handleInputChange}
                placeholder="Enter URL"
                required
              />
            </div>

            <div className="FormGroupDiv">
              <label>Status:</label>
              <select
                name="accountStatus"
                value={socialData.accountStatus}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="FormGroupDiv">
              <label>Upload Image:</label>
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
                required
              />
              {socialData.imagePreview ? (
                <div className="image-preview">
                  <img
                    src={socialData.imagePreview}
                    alt="Preview"
                    style={{ width: '150px', height: '150px', marginTop: '10px', borderRadius: '8px' }}
                  />
                </div>
              ) : (
                <p></p> // Message if no image is selected
              )}
            </div>

            <div className="SubMit">
              <button type="submit">Submit</button>
            </div>
          </Form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default AddSocialLinks;
